module.exports = __webpack_public_path__ + "static/media/publicsonar_naturaldisaster_hover.a1f44df9.svg";